import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import ReactQuill from 'react-quill';
import { NotesTabHeadRow } from './NotesTabHeadRow';
import NotesTabTableRow from './NotesTabTableRow';
import { MAX_MESSAGE_LENGTH } from 'components/constants';
import Loader from 'components/Loader';
import i18nContext from 'components/i18n-context';
import OperatorsAsyncSelect from 'components/OperatorsAsyncSelect';
import { convertHtmlToString, convertMessageToHtmlAndTrimSpaces } from 'services/utils';
import Button from 'uikit/Button/Button';
import './NotesTab.scss';

const NotesTab = ({
  isLoading,
  notes,
  transactionNumber,
  handleLoadNotes,
  handleAddNote,
  handleDeleteNote,
  handleDownloadDocument
}) => {
  const [noteValue, setNoteValue] = useState('');
  const [assigneeOperator, setAssigneeOperator] = useState(null);
  const [documents, setDocuments] = useState([]);
  const i18n = useContext(i18nContext);

  useEffect(() => {
    handleLoadNotes();
  }, []);

  const addNote = () => {
    const convertedNote = convertMessageToHtmlAndTrimSpaces(noteValue, assigneeOperator?.id);
    (transactionNumber
      ? handleAddNote(transactionNumber, convertedNote, assigneeOperator?.id, documents)
      : handleAddNote(convertedNote, assigneeOperator?.id, documents)
    ).then(() => {
      setNoteValue('');
      setAssigneeOperator(null);
      setDocuments([]);
    });
  };

  if (!notes) {
    return <Loader className={'application-loader customer-notes-tab-loader'} />;
  }

  return (
    <div className={'customer-notes-container'}>
      <Table responsive>
        <thead>
          <NotesTabHeadRow />
        </thead>
        <tbody>
          {notes.map((note, index) => (
            <NotesTabTableRow
              key={`${note.id} + ${index}`}
              isLoading={false}
              noteData={note}
              handleRemoveNote={handleDeleteNote}
              handleDownloadDocument={handleDownloadDocument}
            />
          ))}
        </tbody>
      </Table>

      <OperatorsAsyncSelect
        className={'customer-notes-select'}
        handleValueChanged={setAssigneeOperator}
        value={assigneeOperator}
      />

      <div className={'customer-notes-container-input'}>
        <ReactQuill
          value={noteValue}
          onChange={setNoteValue}
          placeholder={i18n.getMessage('customerNotes.input.note.placeholder')}
          style={{ minHeight: '120px' }}
        />
        <p className={'input-sub-text'}>
          {i18n.getMessage('customerNotes.input.note.symbolsLeft', {
            symbolsLeft: MAX_MESSAGE_LENGTH - convertHtmlToString(noteValue).length
          })}
        </p>
      </div>

      <div className={'customer-notes-container-add-note'}>
        <Button
          className={'customer-notes-container-add=note-button'}
          type={'primary'}
          size={'small'}
          onClick={addNote}
          isDisabled={!noteValue || isLoading}
        >
          {isLoading ? <Loader /> : i18n.getMessage('customerNotes.button.addNote')}
        </Button>
      </div>
    </div>
  );
};

NotesTab.propTypes = {
  isLoading: PropTypes.bool,
  notes: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
  transactionNumber: PropTypes.string,
  handleLoadNotes: PropTypes.func,
  handleAddNote: PropTypes.func,
  handleDeleteNote: PropTypes.func,
  handleDownloadDocument: PropTypes.func
};

export default NotesTab;
